import { useSearchParams } from '@shared/hooks/useSearchParams.hook';
import ProjectDashboard from '../dashboard/components/ProjectDashboard';
import { useSetTaskStatus } from '../tasks/api';
import ProjectTasks from '../tasks/components/ProjectTasks';
import TaskViewDialog from '../tasks/components/TaskViewDialog';
import { TASK_DIALOG_PARAM } from '../tasks/constants';
import type { ETaskStatus, TTaskListItem } from '../tasks/types';
import { EProjectView, type TProject } from '../types';

type TProps = {
  project: TProject;
  view: EProjectView;
  rootItemId: string;
};

const ProjectTaskViews = ({ project, view, rootItemId }: TProps) => {
  const { searchParams } = useSearchParams();
  const taskId = searchParams.get(TASK_DIALOG_PARAM) ?? '';
  // One status mutation for the rows and the dialog: a pending change from either locks both.
  const status = useSetTaskStatus();
  const onStatusChange = (task: TTaskListItem, value: ETaskStatus) => status.mutate({ id: task._id, status: value });
  return (
    <>
      {view === EProjectView.DASHBOARD ? (
        <ProjectDashboard project={project} statusPending={status.isPending} onStatusChange={onStatusChange} />
      ) : (
        <ProjectTasks
          project={project}
          rootItemId={rootItemId}
          statusPending={status.isPending}
          onStatusChange={onStatusChange}
        />
      )}
      <TaskViewDialog
        project={project}
        rootItemId={rootItemId}
        taskId={taskId}
        statusPending={status.isPending}
        onStatusChange={(value) => status.mutate({ id: taskId, status: value })}
      />
    </>
  );
};
export default ProjectTaskViews;
